module.exports = __webpack_public_path__ + "static/img/c.396df64d.png";